import { Icon, type IconGlyph } from '@sunwebgroup/uds-ui/icon'
import * as React from 'react'
import { ServiceType } from '../domain/types'

export function ServiceIcon({ type, size, className }: { type: string, size: 16 | 24 | 32 } & { className?: string }) {
  const serviceIcon = getIconForService(type)
  if (!serviceIcon) {
    return null
  }
  return <Icon glyph={serviceIcon} size={size} className={className} />
}

export function getIconForService(key: string): IconGlyph | undefined {
  const serviceIconMap: Record<string, IconGlyph> = {
    'participantsBadge': 'Family',
    'group': 'Family',
    'cutlery': 'ForkAndKnive',
    'airplane': 'AirplaneToTop',
    'suitcase': 'SuitcaseOnWheels',
    'skimaterial': 'Skis',
    'skipass': 'SkiPass',
    'skilesson': 'PersonSkiing',
    'flight': 'AirplaneToTop',
    'Flight': 'AirplaneToTop',
    'Accommodation': 'Bed',
    'accommodation': 'Bed',
    'Bed': 'Bed',
    'building': 'AppartmentBuilding',
    'Mealplan': 'ForkAndKnive',
    'carrental': 'CarRight',
    'transfer': 'BusRight',
    'BRIDGE*': 'SpadeSymbol',
    [ServiceType.CarRentalFiltering]: 'CarRight',
    [ServiceType.TravelInsurance]: 'SuitcaseOnWheelsWithCheckMark',
    [ServiceType.TravelInsurancePerBooking]: 'SuitcaseOnWheelsWithCheckMark',
    [ServiceType.CancellationInsurance]: 'ShieldWithDismiss',
    [ServiceType.MealplanDP]: 'ForkAndKnive',
    [ServiceType.BookingRedeem]: 'ArrowsCirclePath',
    [ServiceType.Luggage]: 'Suitcase',
    [ServiceType.SkiPass]: 'SkiPass',
    [ServiceType.SkiMaterial]: 'Skis',
    [ServiceType.SkiLesson]: 'PersonSkiing',
    [ServiceType.TShirt]: 'TShirt',
    [ServiceType.Sweater]: 'Sweater',
    [ServiceType.Golf]: 'GolfClub',
    [ServiceType.Bridge]: 'SpadeSymbol',
    [ServiceType.DinnerVouchers]: 'ForkAndKnive',
    [ServiceType.Bus]: 'BusRight',
    'money': 'PaymentCardWithCoins',
    'AUTOHUUR*': 'CarRight',
    'TRAVEL*': 'SuitcaseOnWheelsWithCheckMark',
    'CANCEL*': 'ShieldWithDismiss',
    'TRANSFER': 'BusRight',
    'VISA*': 'DocumentWithText',
    'REBOOKING': 'ArrowsSquarePath',
    'REBOOKING*': 'ArrowsSquarePath',
    'BABY*': 'Baby',
    'ACCOMMODATION': 'ForkAndKnive',
    'VERZORGING*': 'ForkAndKnive',
    'HALFBOARD*': 'ForkAndKnive',
    'BREAKFAST': 'ForkAndKnive',
    'BREAKFARRHINT_00': 'ForkAndKnive',
    'DINNER': 'ForkAndKnive',
    'REDEEM': 'ArrowsCirclePath',
    'LUG_*': 'Suitcase',
    'SKI*': 'SkiPass',
    'SKIPAS*': 'SkiPass',
    'SKIP*': 'SkiPass',
    'SKIHUUR*': 'Skis',
    'SKIH*': 'Skis',
    'SKILES*': 'PersonSkiing',
    'SKIL*': 'PersonSkiing',
    'SWEATER*': 'Sweater',
    'TSHIRT*': 'TShirt',
    'DUTCHWEEK1': 'TicketFlight',
    'DUTCHWEEK': 'TicketFlight',
    'COMEDY': 'Ticket',
    'PARKEREN': 'ParkingSign',
    'GARAGE': 'ParkingSign',
    'SHAREDBUS': 'BusRight',
    'CARRIAGESKI*': 'SuitcaseOnWheels',
    'PARTY': 'TicketFlight',
    'Bus': 'BusRight',
    'BUS': 'BusRight',
    'GREENFEE': 'GolfClub',
    'BRIDGE': 'Ticket',
    'MEAL-VOUCHERS': 'ForkAndKnive',
    'ESIM': 'Esim',
    'TOWEL*': 'Towel',
    'SHEETS*': 'BedSheets',
    'FIETS': 'Bike',
  }

  return serviceIconMap[key]
}
